import { RequestOptions } from 'https';

import { CHROME_WINDOWS } from './user-agent';

export const BASE_HTTPS_OPTIONS: RequestOptions = {
  port: 443,
  path: '/',
  method: 'GET',
  headers: {
    'User-Agent': CHROME_WINDOWS,
  },
};
